import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SurveyProcessingApi } from '../../api/survey-processing/survey-processing.api';

@Injectable({ providedIn: 'root' })
export class SurveyProcessingService {
  private readonly _api = inject(SurveyProcessingApi);

  public updateManualProcessing(
    buyerConfigSettingsId: string,
    companyId: number,
    enable: boolean,
  ): Observable<void> {
    return this._api.updateManualProcessing(
      buyerConfigSettingsId,
      companyId,
      enable,
    );
  }
}
